'use client';

import { useEffect } from 'react';
import { Head } from '@nx-frontend/shared/ui';
import { generalEnv } from '@nx-frontend/shared/env';
import { useRouter, usePathname } from '@nx-frontend/shared/hooks/router-proxy';
import { useAppNavHistory } from '@nx-frontend/shared/utils/use-app-nav-history';

interface PageWithFrameProps {
  title: string;
  frameUrl: string;
}

/**
 * Component that renders a page with iframe
 * @param props
 * @returns
 */
export function PageWithFrame(props: PageWithFrameProps) {
  const { title, frameUrl } = props;

  const router = useRouter();
  const pathname = usePathname() || '';
  const history = useAppNavHistory(pathname);

  useEffect(function () {
    const onWindowPostMessage = function onWindowPostMessage(message: MessageEvent) {
      if (
        generalEnv.adminClientUrl.toLowerCase().includes(message.origin.toLocaleLowerCase()) ||
        generalEnv.env === 'local'
      ) {
        if (message.data === 'back') {
          const prevUrl = history[history.length - 2];
          if (prevUrl && !(prevUrl.startsWith('/settings') || prevUrl.startsWith('/space/settings'))) {
            router.push(prevUrl);
          } else {
            // fallback to default back, if prevUrl is not available or is settings page
            router.back();
          }
        }
      }
    };
    window.addEventListener('message', onWindowPostMessage);
    return function () {
      window.removeEventListener('message', onWindowPostMessage);
    };
  });

  const layout = (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <iframe className="page-with-frame__frame w-full h-full" title={title} src={frameUrl}></iframe>
    </>
  );

  return layout;
}
